import { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || "https://vedonica.in/api/products/testimonials/";

function ScreenshotCard({ t }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  return (
    <div style={{
      width: "280px",
      flexShrink: 0,
      borderRadius: "18px",
      border: "2px solid #bbf7d0",
      background: "#ffffff",
      overflow: "hidden",
      boxShadow: "0 6px 24px rgba(34,197,94,0.12)",
      transition: "transform 0.25s, box-shadow 0.25s",
    }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-6px) scale(1.02)";
        e.currentTarget.style.boxShadow = "0 16px 40px rgba(34,197,94,0.25)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0) scale(1)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(34,197,94,0.12)";
      }}
    >
      <div style={{
        position: "relative",
        width: "100%",
        height: "480px",
        background: "#f0fdf4",
        overflow: "hidden",
      }}>
        {!imgLoaded && !imgError && (
          <div style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            background: "#f0fdf4",
          }}>
            <div style={{
              width: "36px",
              height: "36px",
              border: "3px solid #bbf7d0",
              borderTopColor: "#16a34a",
              borderRadius: "50%",
              animation: "testi-spin 0.8s linear infinite",
            }} />
            <span style={{ fontSize: "12px", color: "#86efac" }}>Loading...</span>
          </div>
        )}

        {imgError && (
          <div style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            background: "#f0fdf4",
          }}>
            <i className="fa-solid fa-image" style={{ color: "#bbf7d0", fontSize: "40px" }}></i>
            <span style={{ fontSize: "11px", color: "#86efac" }}>No image</span>
          </div>
        )}

        {t.screenshot_url && (
          <img
            src={t.screenshot_url}
            alt="client testimonial"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgError(true)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "top",
              display: imgLoaded ? "block" : "none",
            }}
          />
        )}
      </div>
    </div>
  );
}

function SkeletonCard() {
  return (
    <div style={{
      width: "280px",
      flexShrink: 0,
      borderRadius: "18px",
      border: "2px solid #bbf7d0",
      overflow: "hidden",
    }}>
      <div style={{
        height: "480px",
        background: "linear-gradient(90deg, #f0fdf4 25%, #dcfce7 50%, #f0fdf4 75%)",
        backgroundSize: "200% 100%",
        animation: "testi-shimmer 1.5s infinite",
      }} />
    </div>
  );
}

export default function TestimonialMarquee() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    fetch(API_URL)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {
        setTestimonials(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const doubled = [...testimonials, ...testimonials];

  return (
    <div style={{
      width: "100%",
      overflow: "hidden",
      padding: "clamp(1.5rem, 4vw, 3rem) 0",
      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 50%, #dcfce7 100%)",
      fontFamily: "'Segoe UI', sans-serif",
    }}>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />
      <style>{`
        @keyframes testi-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes testi-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        @keyframes testi-spin {
          to { transform: rotate(360deg); }
        }
        .testi-track {
          display: flex;
          gap: 20px;
          width: max-content;
          animation: testi-marquee 40s linear infinite;
          padding: 14px 0;
        }
        .testi-track.paused {
          animation-play-state: paused;
        }
        @media (max-width: 600px) {
          .testi-card-inner { width: 220px !important; }
          .testi-card-inner > div { height: 380px !important; }
          .testi-skeleton-inner { width: 220px !important; }
          .testi-skeleton-inner > div { height: 380px !important; }
        }
      `}</style>

      <div style={{ textAlign: "center", marginBottom: "clamp(1rem, 3vw, 2rem)", padding: "0 1rem" }}>
        <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          background: "#dcfce7",
          border: "1px solid #86efac",
          borderRadius: "20px",
          padding: "5px 16px",
          marginBottom: "12px",
        }}>
          <i className="fa-solid fa-leaf" style={{ color: "#16a34a", fontSize: "11px" }}></i>
          <span style={{ fontSize: "12px", color: "#15803d", fontWeight: "600" }}>Real Client Results</span>
        </div>
        <h4 style={{
          fontSize: "clamp(18px, 4vw, 28px)",
          fontWeight: "700",
          color: "#14532d",
          letterSpacing: "-0.5px",
          margin: "0 0 6px",
        }}>Our Trusted Client Reviews</h4>
        <p style={{
          fontSize: "clamp(11px, 2vw, 14px)",
          color: "#16a34a",
          margin: 0,
        }}>Real WhatsApp screenshots · Real transformations</p>
      </div>

      {error && (
        <div style={{
          textAlign: "center",
          padding: "2rem",
          color: "#15803d",
          fontSize: "14px",
        }}>
          <i className="fa-solid fa-circle-exclamation" style={{ marginRight: "6px" }}></i>
          Could not load testimonials. Check backend connection.
        </div>
      )}

      {!error && (
        <div
          style={{
            overflow: "hidden",
            width: "100%",
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)",
            maskImage: "linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)",
          }}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
        >
          {loading ? (
            <div style={{ display: "flex", gap: "20px", padding: "14px 1rem" }}>
              {[1, 2, 3, 4].map(i => <SkeletonCard key={i} />)}
            </div>
          ) : (
            <div className={`testi-track${paused ? " paused" : ""}`}>
              {doubled.map((t, i) => (
                <ScreenshotCard key={`${t.id}-${i}`} t={t} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}